import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { ModalService } from "../../../../core-ui/services/modal.service";

@Component({
  selector: "av-modal-container",
  templateUrl: "./modal-container.component.html",
  styleUrls: ["./modal-container.component.scss"],
  standalone: false,
})
export class ModalContainerComponent implements OnInit, OnDestroy {
  private modalService = inject(ModalService);


  ngOnInit(): void {
    this.modalService.setVisibility(true);
  }

  ngOnDestroy(): void {
    this.modalService.setVisibility(false);
  }
}
